<div *ngIf="isRange; else datePicker" id="date-range-picker-parent"
     [class.date-picker-invalid]="rangeInvalid"
     [class.date-picker-with-pill]="showPill"
     [ngStyle]="{ 'background-color': backgroundColor }">
    <!-- The literal id/for pairs are for static a11y checks; the bindings make them unique per instance at runtime. -->
    <label class="visually-hidden" for="date-range-start" [for]="startInputId">{{ 'DATE.START_DATE' | translate }}</label>
    <label class="visually-hidden" for="date-range-end" [for]="endInputId">{{ 'DATE.END_DATE' | translate }}</label>
    <mat-form-field id="date-range-picker-container" [subscriptSizing]="'dynamic'">
        <mat-date-range-input [rangePicker]="picker" [min]="min" [max]="max" [required]="required">
            <input matStartDate #startInput id="date-range-start" [id]="startInputId"
                   [placeholder]="placeholder" name="start-date"
                   [(ngModel)]="dateRangeStart"
                   [disabled]="disabled" (focus)="onRangeFocus()" (blur)="onDateRangeBlur($event)" />
            <input matEndDate #endInput id="date-range-end" [id]="endInputId"
                   [placeholder]="placeholder" name="end-date"
                   [(ngModel)]="dateRangeEnd"
                   [disabled]="disabled" (focus)="onRangeFocus()" (blur)="onDateRangeBlur($event)" />
        </mat-date-range-input>
        <mat-datepicker-toggle matIconSuffix [for]="picker" [disabled]="disabled"></mat-datepicker-toggle>
        <mat-date-range-picker #picker (closed)="onPickerClosed()"></mat-date-range-picker>
    </mat-form-field>

    <button type="button" *ngIf="hasRangeText && !disabled && !pillVisible"
            (click)="clearDateRange()"
            class="date-picker-clear-button"
            [attr.aria-label]="'DATE.CLEAR_DATES' | translate">
        <rms-clear-icon></rms-clear-icon>
    </button>

    <div class="date-pill-overlay" *ngIf="pillVisible">
        <button type="button" class="date-pill-edit"
                (mousedown)="$event.preventDefault()" (click)="onPillEdit()"
                [attr.aria-label]="'DATE.EDIT_DATES' | translate"></button>
        <span class="date-pill" [class.invalid]="rangeInvalid">
            {{pillLabel}}
            <button type="button" class="date-pill-x" (click)="onPillClear()"
                    [attr.aria-label]="'DATE.CLEAR_DATES' | translate">&times;</button>
        </span>
    </div>
</div>
<ng-template #datePicker>
    <div id="date-picker-parent" [style.height]="height ? height + 'px' : null" [ngStyle]="{ 'background-color': backgroundColor }">
        <input class="form-control"
               [(ngModel)]="dateSelect"
               (ngModelChange)="onDateChanged()"
               (blur)="onDateBlur()"
               [style.height]="height ? height + 'px' : null"
               [matDatepicker]="picker"
               [disabled]="disabled"
               [placeholder]="placeholder"
               [min]="min"
               [max]="max"
               [required]="required" />
        <mat-datepicker-toggle matIconSuffix [for]="picker"
                               [disabled]="disabled"
                               [style.--mdc-icon-button-state-layer-size]="height ? height + 'px' : null">
        </mat-datepicker-toggle>
        <mat-datepicker #picker></mat-datepicker>
    </div>
</ng-template>
